import { memo } from 'react'

import { usdFormatter } from '@repo/common/helpers/formatters'
import { useGetWalletBalance } from '@repo/common/queries/blockchain/useGetWalletBalance'
import { useGetTokenPrice } from '@repo/common/queries/fission_dex'
import {
  type AllFundSymbol,
  type FundSymbol,
  isActiveFund,
} from '@repo/common/queries/products'

// eslint-disable-next-line complexity
export const ActiveFundAmount = memo<{ symbol: FundSymbol }>(
  function ActiveFundAmount({ symbol }) {
    const price_result = useGetTokenPrice({ symbol })

    const wallet = useGetWalletBalance(symbol)

    if (price_result.isLoading || wallet.isLoading) return null

    let price = 0

    if (price_result.data == null) return null
    price = price_result.data

    const amount = price * wallet.balance

    return <>{usdFormatter(amount)}</>
  },
)

export const FundAmount = memo<{ symbol?: AllFundSymbol }>(function FundAmount({
  symbol,
}) {
  if (symbol == null) return null

  if (isActiveFund(symbol)) {
    return <ActiveFundAmount symbol={symbol as FundSymbol} />
  }
  return 'n/a'
})
